let accordionGroups = $('.accordion-inner');

if(accordionGroups.length) {

    accordionGroups.each(function() {

        let items = $(this).find('.accordion-item');

        items.each(function() {
            let button = $(this).find('button'),
                content = $(this).find('.accordion-content');

            button.on('click', function() {
                let isExpanded = button.attr('aria-expanded') === 'true';

                // Close all items
                items.each(function() {
                    $(this).removeClass('is-open');
                    $(this).find('button').attr('aria-expanded', 'false');
                    $(this).find('.accordion-content').slideUp();
                });

                // If it was not expanded, open it
                if(!isExpanded) {
                    $(this).parent().addClass('is-open');
                    button.attr('aria-expanded', 'true');
                    content.slideDown();
                } else {
                    content.slideUp();
                }
            });
        });

    });

}
